// src/redux/actions/cityActions.js
import {
    FETCH_GETQUALIFICATION_REQUEST,
    FETCH_GETQUALIFICATION_SUCCESS,
    FETCH_GETQUALIFICATION_FAILURE,
    SET_SELECTED_GETQUALIFICATION,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchQualification = () => async (dispatch) => {
    dispatch({ type: FETCH_GETQUALIFICATION_REQUEST });
  
    try {
      
      const response = await axios.get(`/MasterData/GetQualificationsDDL`);
      console.log("qqq response", response);
      
      let qualificationList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_GETQUALIFICATION_SUCCESS,
        payload: qualificationList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETQUALIFICATION_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectQualification = (qualificationId) => ({
    type: SET_SELECTED_GETQUALIFICATION,
    payload: qualificationId,
  });
  